import { initScopeAngularjs } from './initScopeAngularjs';

FbCellEditorClass.$inject = ['EcCellEditor'];

/**
 * Encapsular el EcCellEditor.
 * no se usa directamente, viaja como servicio angular y se injecta en cada tipo de celda que produce el fbGrid.
 *
 * @param {EcCellEditor} EcCellEditor clase que se pasa como injeción de dependencia
 * @returns {FbCellEditor}
 */

const defaultOptions = { ecCellName: 'FbCellEditor' };

export default function FbCellEditorClass(EcCellEditor) {
  return class FbCellEditor extends EcCellEditor {
    static getMetadata = EcCellEditor.getMetadata;

    constructor(options = {}) {
      super(Object.assign({}, defaultOptions, options));
    }

    prerender() {
      initScopeAngularjs.call(this);
    }
  };
}
